// extracted by mini-css-extract-plugin
export default {"small":"nZl9At+LUT"};